import { attendance } from '@/pages/Attendance/Attendance.i18n.ja'
import { config } from '@/pages/ConfigTimeWork/Config.i18n.ja'

import { admins } from './Admin/Admin.i18n.ja'
import { announcements } from './Announcements/Announcements.i18n.ja'
import { attendanceEmployee } from './AttendanceEmployee/AttendanceEmployee.i18n.ja'
import { attendanceLogs } from './AttendanceLogs/AttendanceLogs.i18n.ja'
import { customers } from './Customer/Customers.i18n.ja'
import { detergentHistories } from './DetergentHistories/DetergentHistories.i18n.ja'
import { detergents } from './Detergents/Detergents.i18n.ja'
import { employees } from './Employees/Employees.i18n.ja'
import { idCards } from './IdCards/IdCards.i18n.ja'
import { languages } from './Languages/Languages.i18n.ja'
import { login } from './Login/Login.i18n.ja'
import { machines } from './Machine/Machines.i18n.ja'
import { machineParts } from './MachineParts/MachineParts.i18n.ja'
import { operators } from './Operators/Operators.i18n.ja'
import { tanks } from './Tank/Tank.i18n.ja'
import { tankHistories } from './TankHistory/TankHistories.i18n.ja'
import { terminals } from './Terminals/Terminals.i18n.ja'
import { uniforms } from './Uniforms/Uniforms.i18n.ja'
import { washingCount } from './WashingCount/WashingCount.i18n.ja'
import { washingHistory } from './WashingHistory/WashingHistory.i18n.ja'
import { washingMachinePart } from './WashingMachinePart/WashingMachinePart.i18n.ja'
import { washingMethods } from './WashMethods/WashingMethods.i18n.ja'
export const pages = {
  announcements,
  employees,
  idCards,
  languages,
  terminals,
  uniforms,
  attendanceLogs,
  login,
  admins,
  attendanceEmployee,
  attendance,
  config,
  customers,
  operators,
  machines,
  machineParts,
  detergents,
  detergentHistories,
  washingMethods,
  washingCount,
  washingMachinePart,
  tanks,
  tankHistories,
  washingHistory,
}
